import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "aria-expanded"]
const _hoisted_2 = ["aria-labelledby"]

import {ref, Ref, onMounted, onBeforeUnmount} from 'vue';

    type Props = {
        id: string;
        menuClass?: string;
    };

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
    id: {},
    menuClass: { default: '' }
  },
  setup(__props: any) {

    

    const isOpen = ref(false);
    const dropdownRef: Ref<HTMLDivElement | null> = ref(null);

    function toggleDropdown() {
        isOpen.value = !isOpen.value;
    }

    function clickOutsideDropDownListener(event: MouseEvent) {
        if (isOpen.value && !dropdownRef.value?.contains(event.target as Node)) {
            isOpen.value = false;
        }
    }

    onMounted(() => {
        document.addEventListener('click', clickOutsideDropDownListener);
    });

    onBeforeUnmount(() => {
        document.removeEventListener('click', clickOutsideDropDownListener);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dropdownRef",
    ref: dropdownRef,
    class: "dropdown"
  }, [
    _createElementVNode("button", {
      id: _ctx.id,
      type: "button",
      class: _normalizeClass({'dropdown-header': true, open: isOpen.value}),
      "aria-expanded": isOpen.value,
      onClick: toggleDropdown
    }, [
      _renderSlot(_ctx.$slots, "header")
    ], 10, _hoisted_1),
    _createElementVNode("div", {
      role: "region",
      class: _normalizeClass({'dropdown-content': true, open: isOpen.value, [_ctx.menuClass]: true}),
      "aria-labelledby": _ctx.id
    }, [
      _renderSlot(_ctx.$slots, "content")
    ], 10, _hoisted_2)
  ], 512))
}
}

})